import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import { useStore } from 'vuex';
import VitaMobileScreen from '@/components/VitaMobileScreen.vue';
import { isMobile } from '@/utils/main';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore()

const closeErrorMessage = () => {
  store.commit('data/closeErrorDialog', '')
}

const errorMessage = computed<string | null>(() => {
  return store.getters['data/errorModal']
})

const loader = computed<boolean>(() => {
  return store.getters['user/loader']
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_vita_button = _resolveComponent("vita-button")!
  const _component_vita_modal = _resolveComponent("vita-modal")!
  const _component_vita_loader = _resolveComponent("vita-loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isMobile))
      ? (_openBlock(), _createBlock(VitaMobileScreen, { key: 0 }))
      : (_openBlock(), _createBlock(_component_router_view, { key: 1 })),
    (errorMessage.value)
      ? (_openBlock(), _createBlock(_component_vita_modal, {
          key: 2,
          title: errorMessage.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_vita_button, {
              onClick: closeErrorMessage,
              type: "small",
              "data-qa": "app-button-error-close"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("Закрыть", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    (loader.value)
      ? (_openBlock(), _createBlock(_component_vita_loader, { key: 3 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})